<template>
  <div
    v-loading="loading"
    class="l-page l-page--detail l-page--detail-tabs"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        class="c-page__header-title"
      >
        编辑评估项目
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="保存项目信息"
          :auth-type="true"
          type="primary"
          icon="kestrel-icon ki-save"
          :loading="btnLoading"
          @click="handleSave"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DSC'"
          v-permission-element="'pgxm_scbg'"
          btn-text="生成报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="handleScbg()"
        />
        <k-button
          v-if="xmInfo.xmzt === 'DSC'"
          v-permission-element="'pgxm_scbg_ls'"
          btn-text="生成临时报告"
          :auth-type="true"
          type="primary"
          plain
          icon="iconfont icon-baogao"
          @click="handleSclsbg()"
        />
        <k-button
          v-if="lsbgFileId"
          btn-text="查看临时报告"
          :auth-type="false"
          type="primary"
          plain
          icon="kestrel-icon ki-file-pdf"
          :disabled="xmInfo.previewPdf"
          @click="(e)=>$utils.previewPdf(e,lsbgFileId,xmInfo)"
        >
          <i
            v-show="xmInfo.previewPdf"
            class="el-icon-loading"
          />
        </k-button>
        <k-button
          btn-text="关闭"
          :auth-type="false"
          icon="kestrel-icon ki-close"
          @click="closeNavTabAndTo()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 页面主内容：仅tabs为主内容 Start -->
    <div
      class="l-page__body l-page--detail__body"
    >
      <el-tabs
        v-model="activeName"
        type="border-card"
        class="l-page__tabs l-page__tabs--full"
      >
        <el-tab-pane
          label="项目信息"
          name="xmInfo"
        >
          <update-xminfo
            ref="xmInfo"
            type="xmInfo"
            @updateXminfo="handleXminfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="实施规划"
          name="action"
        >
          <action-info
            ref="actionInfo"
            type="actionInfo"
            :xm-info="xmInfo"
          />
        </el-tab-pane>
        <el-tab-pane
          label="评估明细"
          name="pgmx"
        >
          <pgmx-list
            ref="pgmxList"
            type="pgmxList"
          />
        </el-tab-pane>

      <!-- 页面主内容：仅tabs为主内容 End -->
      </el-tabs>
    </div>
  </div>
</template>

<script>
import updateXminfo from './updateXminfo.vue';
import pgmxList from './pgmxList.vue';
import actionInfo from './actionInfo.vue';
import { pgxmManageService } from '../pgxm.service';
export default {
  name: 'EditPgxm',
  components: {
    updateXminfo,
    pgmxList,
    actionInfo
  },
  data () {
    return {
      loading: false, // 页面loading状态
      activeName: 'xmInfo',
      xmId: null,
      xmInfo: {}, // 维保项目信息
      lsbgFileId: null, // 临时报告文件id
      btnLoading: false
    };
  },
  methods: {
    /**
     * @description: 维保项目信息处理
     * @return {*}
     * @param {*} data
     */
    handleXminfo (data) {
      this.xmInfo = data;
    },
    /**
     * @description: 保存项目信息
     * @return {*}
     */
    async handleSave () {
      this.btnLoading = true;
      this.activeName = 'xmInfo';
      this.$refs.xmInfo.handleSave().then(async resp => {
        if (!resp) {
          await resp;
        }
        this.btnLoading = false;
      });
    },
    /**
     * @description: 新增建筑
     * @return {*}
     */
    handleAddJz () {
      this.activeName = 'wbjz';
      this.$refs.wbjzList.handleDialog('add', { dlType: 'add' });
    },
    /**
     * @description: 生成临时报告
     * @return {*}
     */
    handleSclsbg () {
      const _this = this;
      _this.loading = true;
      pgxmManageService.sclsbg(_this.xmId)
        .then(rsp => {
          this.lsbgFileId = rsp.data.data;
          _this.$alert('临时报告生成成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
        })
        .catch(err => {
          _this.$alert('临时生成报告失败！', '提示', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {
            }
          });
          console.error('临时生成报告失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 生成报告
     * @return {*}
     */
    handleScbg () {
      const _this = this;
      _this.$confirm('是否确认生成报告？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          _this.loading = true;
          pgxmManageService.scbg(_this.xmId)
            .then(rsp => {
              _this.$alert('报告生成成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                  // _this.closeNavTabAndTo({ name: 'pgxmManage', params: { isRefresh: true } }, true);
                }
              });
              _this.$refs.xmInfo.init();
              _this.closeNavTabAndTo({ name: 'pgxmDetail', params: { id: _this.xmId } }, true);
            })
            .catch(err => {
              console.error('报告生成失败！', err);
            })
            .finally(() => {
              _this.loading = false;
            });
        })
        .catch(() => {});
    }
  },
  created () {
    this.xmId = this.$route.params.id;
  }
};
</script>

<style>

</style>
